import styled from 'styled-components';

import { Box } from '@sternum/styled-system';
import { ct } from '@sternum/web/utils/theme';

import { Text } from '../Text';
import { Colors } from '../theme/constants';

export const Container = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: ${ct({ Dark: Colors.DarkerText, Light: Colors.DarkerText })};
`;

export const Content = styled.div`
  position: relative;
  display: grid;
  height: 100%;
  grid-template-columns: auto auto;
  justify-content: center;
  align-items: center;
  padding: 0 60px;
  gap: 10px;
  z-index: 2;

  @media (max-width: 1280px) {
    grid-template-rows: minmax(0, 1fr) auto;
    grid-template-columns: 1fr;
    justify-items: center;
    text-align: center;
    padding: 60px 0;
  }
`;

export const LinesBox = styled(Box)`
  z-index: 1;
`;

export const CodeBox = styled.div`
  height: 100%;
  min-height: 0;

  @media (max-width: 1280px) {
    transform: scale(1.5);
  }
`;

export const LogoBox = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 60px;
`;

export const Title = styled(Text)`
  font-size: 40px;
  font-weight: 600;
  line-height: 60px;
  color: ${ct({ Dark: Colors.BrandBlueLightest, Light: Colors.BrandBlueLightest })};
`;

export const Description = styled(Text)`
  font-size: 18px;
  font-weight: 500;
  color: ${ct({ Dark: Colors.BrandBlueLightest, Light: Colors.BrandBlueLightest })};
`;
